import axios from "axios";
import { sortBy } from "lodash";

import { ResponseWrapper } from "@teamprevent/common/utils";
import { WorkGroupDetailModel } from "@teamprevent/common/workGroup/model";

import { WorkGroupCreateModel, WorkGroupEditModel } from "./model";

class WorkGroupApi {

    private readonly apiUrl = "/api/customer";
    private readonly workGroupApiSegment = "workGroup";
    private getAllCancelTokenSource = axios.CancelToken.source(); // eslint-disable-line import/no-named-as-default-member

    public async getAll(customerId: string): Promise<WorkGroupDetailModel[]> {
        this.getAllCancelTokenSource.cancel("Cancelled to allow subsequent request");
        this.getAllCancelTokenSource = axios.CancelToken.source(); // eslint-disable-line import/no-named-as-default-member
        const response = await axios.get(`${this.apiUrl}/${customerId}/${this.workGroupApiSegment}`);
        const data = response.data as WorkGroupDetailModel[];
        const parsedData = data.map(this.parseModel);
        return sortBy(parsedData, w => w.name.toLowerCase());
    }

    public async detail(customerId: string, workGroupId: string): Promise<WorkGroupDetailModel> {
        const response = await axios.get(`${this.apiUrl}/${customerId}/${this.workGroupApiSegment}/${workGroupId}/`);
        const model = response.data as WorkGroupDetailModel;
        return this.parseModel(model);
    }

    public async save(customerId: string, workGroup: WorkGroupEditModel): Promise<ResponseWrapper<WorkGroupDetailModel>> {
        const response = await axios.put(`${this.apiUrl}/${customerId}/${this.workGroupApiSegment}/${workGroup.id}`, workGroup);
        const model = response.data as ResponseWrapper<WorkGroupDetailModel>;
        return model;
    }

    public async create(customerId: string, workGroup: WorkGroupCreateModel): Promise<ResponseWrapper<WorkGroupDetailModel>> {
        const response = await axios.post(`${this.apiUrl}/${customerId}/${this.workGroupApiSegment}`, workGroup);
        const model = response.data as ResponseWrapper<WorkGroupDetailModel>;
        return model;
    }

    public delete(customerId: string, workGroupId: any): Promise<void> {
        return axios.delete(`${this.apiUrl}/${customerId}/${this.workGroupApiSegment}/${workGroupId}`);
    }

    public async getEmployeesInWorkGroupCount(customerId: string, workGroupId: string): Promise<number> {
        const response = await axios.get(`${this.apiUrl}/${customerId}/${this.workGroupApiSegment}/${workGroupId}/getNumberOfEmployeesInWorkGroup`);
        return response.data as number;
    }

    public parseModel(model: WorkGroupDetailModel): WorkGroupDetailModel {
        return {
            ...model
        };
    }
}

export const workGroupApi = new WorkGroupApi();
